module.exports = "<div class=\"content-area\">\t\n\t\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/phoenix/components/textViewer/textViewer.template.html
// module id = 722
// module chunks = 0